.sedlex-skeleton {
  background: linear-gradient(
    90deg,
    var(--bg-surface-sunken) 25%,
    var(--border-default) 50%,
    var(--bg-surface-sunken) 75%
  );
  background-size: 200% 100%;
  animation: sedlex-shimmer 1.5s infinite;
  border-radius: var(--p-radius-sm);
  display: block;
}

@keyframes sedlex-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
